import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { DistrictAllowIpActions } from './district-allow-ip.redux';
import {
	TPayloadCreateDistrictAllowIpRequest,
	TPayloadDeleteDistrictAllowIpRequest,
	TPayloadGetDistrictAllowIpListRequest,
	TPayloadUpdateDistrictAllowIpRequest,
} from './district-allow-ip.type';

export function* getDistrictAllowIpList(
	action: PayloadAction<TPayloadGetDistrictAllowIpListRequest>
) {
	const { callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetDistrictAllowIpListResponse> =
			yield API.getDistrictAllowIpList();
		yield put(
			DistrictAllowIpActions.getDistrictAllowIpListSuccess({
				list: res?.data || [],
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DistrictAllowIpActions.getDistrictAllowIpListFailure());
	}
}

export function* createDistrictAllowIp(
	action: PayloadAction<TPayloadCreateDistrictAllowIpRequest>
) {
	const { districtId, ipAddress, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<number> = yield API.createDistrictAllowIp(
			{
				districtId: districtId || undefined,
				ipAddress: ipAddress || undefined,
			}
		);
		yield put(DistrictAllowIpActions.createDistrictAllowIpSuccess());
		callback?.(undefined, res?.data);
	} catch (error) {
		callback?.(error);
		yield put(DistrictAllowIpActions.createDistrictAllowIpFailure());
	}
}

export function* deleteDistrictAllowIp(
	action: PayloadAction<TPayloadDeleteDistrictAllowIpRequest>
) {
	const { ids, callback } = action.payload;

	try {
		yield API.deleteDistrictAllowIp(ids);
		yield put(DistrictAllowIpActions.deleteDistrictAllowIpSuccess({ ids }));
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DistrictAllowIpActions.deleteDistrictAllowIpFailure());
	}
}

export function* updateDistrictAllowIp(
	action: PayloadAction<TPayloadUpdateDistrictAllowIpRequest>
) {
	const { id, districtId, ipAddress, callback } = action.payload;

	try {
		const updateFields: API.TUpdateField[] = [];

		if (districtId !== undefined) {
			updateFields.push({ name: 'DISTRICT_ID', value: districtId });
		}
		if (ipAddress !== undefined) {
			updateFields.push({ name: 'IP_ADDRESS', value: ipAddress });
		}

		if (updateFields.length > 0) {
			yield API.updateFields({
				objectName: 'UNIT_DISTRICT_ALLOW_IP',
				id,
				updateFields,
			});
		}

		yield put(DistrictAllowIpActions.updateDistrictAllowIpSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DistrictAllowIpActions.updateDistrictAllowIpFailure());
	}
}
